import { AccountLayout } from "../components/AccountLayout";
import Cover from "../components/BookCover";

export default function WishlistPage({ user, onLogout, wishlist, setWishlist, onView, addCart }) {
    const fmtINR = n => "₹" + n.toLocaleString("en-IN");

    const removeFromWishlist = id => setWishlist(prev => prev.filter(b => b._id !== id));

    return (
        <AccountLayout user={user} onLogout={onLogout}>
            <div className="wishlist-page-wrap" style={{ animation: "fadeUp 0.4s both" }}>
                <style>{`
                    .wishlist-grid {
                        display: grid;
                        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
                        gap: 16px;
                    }
                    .wishlist-card {
                        background: var(--paper);
                        border: 1.5px solid var(--border);
                        border-radius: 18px;
                        padding: 20px;
                        display: flex;
                        gap: 16px;
                        transition: all 0.2s;
                    }
                    @media (max-width: 600px) {
                        .wishlist-grid { grid-template-columns: 1fr !important; }
                        .wishlist-card { padding: 16px !important; }
                    }
                    @media (max-width: 380px) {
                        .wishlist-card { flex-direction: column !important; align-items: center !important; text-align: center !important; }
                        .wishlist-card-content { align-items: center !important; }
                        .wishlist-actions { justify-content: center !important; width: 100% !important; }
                    }
                `}</style>
                <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, fontWeight: 800, color: "var(--ink)", marginBottom: 8 }}>My Wishlist</h2>
                <p style={{ fontSize: 13, color: "var(--text3)", marginBottom: 28 }}>Books you've saved for later. {wishlist.length} item{wishlist.length !== 1 ? "s" : ""}.</p>

                {wishlist.length === 0 ? (
                    <div style={{ background: "var(--paper)", borderRadius: 22, border: "1.5px solid var(--border)", padding: "60px 40px", textAlign: "center" }}>
                        <div style={{ fontSize: 48, marginBottom: 16 }}>💛</div>
                        <h3 style={{ fontFamily: "'Playfair Display',serif", fontWeight: 700, fontSize: 20, marginBottom: 8 }}>Your wishlist is empty</h3>
                        <p style={{ color: "var(--text3)", fontSize: 14, marginBottom: 24 }}>Browse our collection and save books you love!</p>
                    </div>
                ) : (
                    <div className="wishlist-grid">
                        {wishlist.map(book => (
                            <div key={book.id} className="wishlist-card"
                                onMouseEnter={e => { e.currentTarget.style.boxShadow = "var(--shadow)"; e.currentTarget.style.borderColor = "var(--forest)"; }}
                                onMouseLeave={e => { e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.borderColor = "var(--border)"; }}
                            >
                                <div onClick={() => onView(book)} style={{ cursor: "pointer", flexShrink: 0 }}>
                                    <Cover book={book} w={64} h={90} shadow={false} />
                                </div>
                                <div className="wishlist-card-content" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                                    <div onClick={() => onView(book)} style={{ cursor: "pointer" }}>
                                        <div style={{ fontWeight: 700, fontSize: 14, color: "var(--ink)", lineHeight: 1.3, marginBottom: 2 }}>{book.title}</div>
                                        <div style={{ fontSize: 12, color: "var(--text3)", marginBottom: 6 }}>{book.author}</div>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
                                        <span style={{ fontWeight: 800, color: "var(--forest)", fontSize: 15 }}>{fmtINR(book.price)}</span>
                                        <span style={{ textDecoration: "line-through", color: "var(--text4)", fontSize: 12 }}>{fmtINR(book.orig)}</span>
                                    </div>
                                    <div className="wishlist-actions" style={{ display: "flex", gap: 8, marginTop: "auto" }}>
                                        <button className="btn btn-forest" style={{ padding: "7px 14px", fontSize: 11, borderRadius: 8 }} onClick={() => addCart(book)}>Add to Cart</button>
                                        <button onClick={() => removeFromWishlist(book.id)} style={{ background: "none", border: "1px solid var(--border)", borderRadius: 8, padding: "7px 12px", fontSize: 11, fontWeight: 600, cursor: "pointer", color: "var(--terra)", fontFamily: "'Nunito Sans',sans-serif" }}>Remove</button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </AccountLayout>
    );
}
